import React, { useState, useEffect } from 'react';
import useQuery from '../../hooks/use-query';
import Button from 'monday-ui-react-core/dist/Button';
import TextField from 'monday-ui-react-core/dist/TextField';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { DOCUMENTS_VIEW } from '../../constants/view-types';
import './share-view.scss';

export default function ShareView() {
  const query = useQuery();
  const id = query.get('id');
  const [linkCopied, setLinkCopied] = useState(false);

  const link = `${process.env.REACT_APP_BILLING_APP_URL}?view=${DOCUMENTS_VIEW}&id=${id}`;

  useEffect(() => {
    let isSubscribed = true;
    if (linkCopied) {
      setTimeout(() => {
        isSubscribed && setLinkCopied(false);
      }, 2000);
    }

    return () => (isSubscribed = false);
  }, [linkCopied]);

  const onCopyLink = () => {
    setLinkCopied(true);
  };

  return (
    <div className="share-view">
      <div className="image-wrapper">
        <img src="/assets/quote/quote-small.png" alt="" />
      </div>
      <div className="title">Send document</div>
      <div className="subtitle">Copy the link below to share your document</div>
      <div className="link-wrapper">
        <div className="link-text-wrapper">
          <TextField size={TextField.sizes.MEDIUM} value={link} readonly={true} />
        </div>
        <CopyToClipboard text={link} onCopy={onCopyLink}>
          <Button color={linkCopied ? Button.colors.POSITIVE : Button.colors.PRIMARY}>
            {linkCopied ? 'Copied!' : 'Copy'}
          </Button>
        </CopyToClipboard>
      </div>
      <div className="notice">Any changes you’ll make in the document won’t effect this link. </div>
    </div>
  );
}
